import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

// Staff view of the client questionnaire, submission, further-information requests and history on the canonical tax return.
export const TaxReturnPortalPanel = ({ taxReturnId }) => {
  const [v, setV] = useState(null);
  const [item, setItem] = useState('');
  const load = useCallback(() => api.get(`/api/portal-staff/tax-returns/${taxReturnId}`).then(({ data }) => setV(data)).catch(() => {}), [taxReturnId]);
  useEffect(() => { load(); }, [load]);
  if (!v) return null;
  const ask = () => api.post(`/api/portal-staff/tax-returns/${taxReturnId}/info-requests`, { items: [item] }).then(() => { toast.success('Request sent to the client'); setItem(''); load(); })
    .catch((e) => toast.error(e.response?.data?.detail || 'Could not send'));
  const labels = Object.fromEntries(v.sections.flatMap((s) => s.questions.map((q) => [q.key, q.label])));
  return (
    <Card data-testid="tax-return-portal-panel">
      <CardHeader><CardTitle className="text-base flex items-center gap-2">Client questionnaire <Badge data-testid="staff-tr-portal-status">{v.portal_status.replace('_', ' ')}</Badge></CardTitle>
        {v.submitted_at && <p className="text-xs text-muted-foreground">Submitted {new Date(v.submitted_at).toLocaleString('en-AU')}</p>}</CardHeader>
      <CardContent className="space-y-4 text-sm">
        {Object.entries(v.answers).map(([k, a]) => <p key={k}><span className="text-muted-foreground">{labels[k] || k}:</span> {a}</p>)}
        {v.documents.map((d) => <p key={d.id}>📎 {d.filename}</p>)}
        {v.info_requests.map((r) => <div key={r.id} data-testid={`staff-info-${r.id}`}>{r.text} – <Badge variant="outline">{r.status}</Badge> {r.response}</div>)}
        <div className="flex gap-2 max-w-xl">
          <Input value={item} onChange={(e) => setItem(e.target.value)} placeholder="Request further information…" data-testid="staff-info-input" />
          <Button size="sm" onClick={ask} disabled={!item.trim()} data-testid="staff-info-send">Request</Button>
        </div>
        <div>{v.history.map((h) => <p key={h.at} className="text-xs text-muted-foreground">{new Date(h.at).toLocaleString('en-AU')} · {h.event}</p>)}</div>
      </CardContent>
    </Card>
  );
};
